import * as React from 'react';
import { ListGroup } from 'react-bootstrap';
import { useMyTimeTrackingQuery } from '../../../__generated__/graphql';
import FlairCard from '../../../../../atomic/templates/FlairCard/FlairCard';
import { useNamespacedTranslation } from '../../../../../hooks/useNamespacedTranslation';
import LoadingWidget from '../CommonComponents/LoadingWidget';
import StartTimeTrackingButton from './StartTimeTrackingButton';
import TimeBadge from './TimeBadge';
import { useTimeTrackingRestriction } from '../../../hooks/timeTrackingSettings';
import { useProjectsShowTrackedTime } from '../../../hooks/timeTracking/useProjectsShowTrackedTime';
import ProjectSelectStep from '../../TimeTracking/CurrentTimeTracking/ProjectSelectStep';
import { toISODateOnly } from '../../../../../utils/dateUtils';

const i18Path = 'dashboard.timeTracking';

const TimeTrackingWidget: React.FC = () => {
  const t = useNamespacedTranslation(i18Path);
  const { data, loading, error } = useMyTimeTrackingQuery();
  const { getTimeTrackingRestrictedReason } = useTimeTrackingRestriction();
  const { isTimeTrackingWithProjects } = useProjectsShowTrackedTime();
  if (loading) return <LoadingWidget />;

  if (error || data === undefined) return null;

  const currentTimeEntry = data.me.currentTimeEntry;
  const status = currentTimeEntry ? t('running') : t('notRunning');

  const isTimeTrackedEnabled =
    currentTimeEntry ||
    !getTimeTrackingRestrictedReason(toISODateOnly(new Date()));

  if (!isTimeTrackedEnabled) {
    return null;
  }

  const rightSideElm = currentTimeEntry ? (
    <TimeBadge currentTimeEntry={currentTimeEntry} />
  ) : (
    <StartTimeTrackingButton />
  );

  return (
    <FlairCard
      cardContainerClassName="time-tracking-card"
      data-testid="time-tracking-card"
      contentClassName="py-4">
      <div className="d-flex justify-content-between align-items-center">
        <div>
          <div className="h2-mini fs-2">{t('title')}</div>
          <div className="h4-regular status" data-testid="time-tracking-status">
            {status}
          </div>
        </div>
        {rightSideElm}
      </div>
      {currentTimeEntry && isTimeTrackingWithProjects && (
        <ListGroup variant="flush" className="mt-3">
          <ProjectSelectStep
            timeEntryId={currentTimeEntry.Id}
            selectedProjectId={
              currentTimeEntry.flair__Tracking_Project__c ?? null
            }
            startDatetime={currentTimeEntry.flair__Start_Datetime__c}
          />
        </ListGroup>
      )}
    </FlairCard>
  );
};

export default TimeTrackingWidget;
